
























































































import Vue from 'vue';
import { Component, Prop, Watch, Model } from 'vue-property-decorator';
import CustomDialog from '@/components/tools/CustomDialog.vue';
import ReadOnlyTextField from '@/components/ReadOnlyTextField.vue';

@Component({
  components: {
    CustomDialog,
    ReadOnlyTextField,
  },
})
export default class Receive extends Vue {
    @Prop({ default: false }) public open!: boolean;

    // Dialog property
    public headerTitle = '';
    public contentHeight = '500px';

    // Action Button Property
    public rightButtonShow = false;
    public rightButtonLabel = 'Cancel';
    public leftButtonShow = false;
    public leftButtonLabel = 'Ok';

    // show: indicator to show verifier dialog
    public show = this.open;

    // view: indicator to change the content
    public view = 'illustration';
    public buttonLabel = '';

    public showAvatar = true;

    public onButtonClicked() {
        if (this.view === 'illustration') {
            this.changeView('qrcode');
        } else {
            this.$emit('update:open', false);
        }
    }

    public changeView(view: string) {
      this.view = view;
    }

    public onLeftActionButtonClicked() {
        if (this.view === 'illustration') {
            // do nothing because the button does not show up
        } else {
            // do nothing because the button does not show up
        }
    }

    public onRightActionButtonClicked() {
        if (this.view === 'illustration') {
            this.changeView('qrcode');
        } else {
            this.$emit('update:open', false);
        }
    }

    @Watch('open')
    private onOpenChange(val: boolean) {
      this.show = val;
      if (val) {
        // every time it's open it will always open illustration
        this.view = 'illustration';
      }
    }

    @Watch('show')
    private onShowChange(val: boolean) {
      if (!val) {
        // if it close then
        // emit to parent component to change the prop
        this.$emit('update:open', false);
      }
    }

    @Watch('view')
    private onViewChange(val: boolean) {
        if (this.view === 'illustration') {
            this.buttonLabel = 'Show My QR Code';
        } else {
            this.buttonLabel = 'Ok';
        }
    }

    @Watch('view', { immediate: true, deep: true })
    private onViewChanged(val: string, oldVal: string) {
        if (this.view === 'illustration') {
            this.leftButtonShow = false;
            this.rightButtonShow = true;
            this.rightButtonLabel = 'Show My QR Code';
        }  else {
            this.leftButtonShow = false;
            this.rightButtonShow = true;
            this.rightButtonLabel = 'Ok';
        }
    }

}
